import { ref, onMounted, onBeforeUnmount } from 'vue';

export function useInterval(func, period, running) {
	const timer = ref(null);
	const isRunning = ref(running);
	onMounted(() => {
		timer.value = setInterval(() => {
			if (isRunning.value) {
				func();
			}
		}, period);
	})
	onBeforeUnmount(() => clearInterval(timer.value));
	return {
		isRunning,
	};
}
